var _defs, _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreImplementationFinalConversionLuminousBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1600,
    height: 520,
    viewBox: "0 0 1600 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore final conversion luminous background") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "fc-final-blue"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fc-final-pink"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2775",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2775",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fc-final-line"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#74BDFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2775",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 520,
    fill: "#020716"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1230,
    cy: 80,
    r: 430,
    fill: "url(#fc-final-blue)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 500,
    r: 340,
    fill: "url(#fc-final-pink)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 260,
    r: 90,
    fill: "none",
    stroke: "url(#fc-final-line)",
    strokeWidth: 2,
    opacity: 0.9
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 260,
    r: 135,
    fill: "none",
    stroke: "url(#fc-final-line)",
    strokeWidth: 1,
    opacity: 0.8200000000000001
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 260,
    r: 180,
    fill: "none",
    stroke: "url(#fc-final-line)",
    strokeWidth: 1,
    opacity: 0.74
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 260,
    r: 225,
    fill: "none",
    stroke: "url(#fc-final-line)",
    strokeWidth: 1,
    opacity: 0.66
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 260,
    r: 270,
    fill: "none",
    stroke: "url(#fc-final-line)",
    strokeWidth: 1,
    opacity: 0.5800000000000001
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 260,
    r: 315,
    fill: "none",
    stroke: "url(#fc-final-line)",
    strokeWidth: 1,
    opacity: 0.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 260,
    r: 360,
    fill: "none",
    stroke: "url(#fc-final-line)",
    strokeWidth: 1,
    opacity: 0.42000000000000004
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 260,
    r: 405,
    fill: "none",
    stroke: "url(#fc-final-line)",
    strokeWidth: 1,
    opacity: 0.33999999999999997
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 420C360 210 530 450 800 260s410 120 730-120",
    fill: "none",
    stroke: "url(#fc-final-line)",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 60,
    r: 3,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 143,
    r: 1.5,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 226,
    r: 1.5,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 491,
    cy: 309,
    r: 1.5,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628,
    cy: 392,
    r: 3,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765,
    cy: 75,
    r: 1.5,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 902,
    cy: 158,
    r: 1.5,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1039,
    cy: 241,
    r: 1.5,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1176,
    cy: 324,
    r: 3,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1313,
    cy: 407,
    r: 1.5,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1450,
    cy: 90,
    r: 1.5,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 173,
    r: 1.5,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 256,
    r: 3,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411,
    cy: 339,
    r: 1.5,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548,
    cy: 422,
    r: 1.5,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685,
    cy: 105,
    r: 1.5,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 822,
    cy: 188,
    r: 3,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 959,
    cy: 271,
    r: 1.5,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1096,
    cy: 354,
    r: 1.5,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1233,
    cy: 437,
    r: 1.5,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1370,
    cy: 120,
    r: 3,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1507,
    cy: 203,
    r: 1.5,
    opacity: 0.55
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreImplementationFinalConversionLuminousBackground);
export default __webpack_public_path__ + "static/media/fleetcore-implementation-final-conversion-luminous-background.099fdbff075dbc7b8d35e9c018e8fb4f.svg";
export { ForwardRef as ReactComponent };